import { React, useEffect, useState, useRef } from "react";
import "./UploadNomination.css";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";

import Axios from "axios";
import Snackbar from "@mui/material/Snackbar";

import TablePagination from "@mui/material/TablePagination";
import { useDispatch, UseSelector } from "react-redux";
import { getTrainingListData, getCurrentMonth } from "../Redux/BussinessPOCSlice";
import { getCount, getNominatedCount } from "../Redux/THSlice";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import Tooltip from "@mui/material/Tooltip";
import { useMsal } from "@azure/msal-react";
import { updateLoginUserName } from "../Redux/BussinessPOCSlice";
import SearchCourse from "../../function-components/TH/SearchCourse";
import TrainingNominationsTemplate from "../../template/TrainingNominationsTemplate.xlsx";

//const baseURL = "http://localhost:15301";
const baseURL = "https://lkmtraining.nomination.accenture.com/LKMtrainingNomination-apis";

const UploadNomination = () => {
 const [nominateButton, setNominateButton] = useState(false);
 const [activeButton, setActiveButton] = useState(false);
 const [uploadNomination, setUploadNomination] = useState("");
 const [open, setOpen] = useState(false);
 const [page, setPage] = useState(0);
 const dispatch = useDispatch();
 let trainingList = useSelector((state) => state.poc.trainingData);
 //  const userEnterpriseID = useSelector((state) => state.poc.enterpriseID);
 const [userEnterpriseID, setuserEnterpriseID] = useState();
 const currentMonth = useSelector((state) => state.poc.currentMonth);
 const currentMonthIndex = useSelector((state) => state.poc.currentMonthIndex);
 let nominatedCount = useSelector((state) => state.traininghost.nominatedCount);
 let rejectedCount = useSelector((state) => state.traininghost.rejectedCount);
 let waitlistCount = useSelector((state) => state.traininghost.waitlistCount);
 let scheduledCount = useSelector((state) => state.traininghost.scheduledCount);
 let approvedCount = useSelector((state) => state.traininghost.approvedCount);
 const [rowsPerPage, setRowsPerPage] = useState(10);
 const [loading, setLoading] = useState(false);
 const [successMessage, setSuccessMessage] = useState("");
 const [errorMessage, setErrorMessage] = useState("");
 const [uploadProgress, setUploadProgress] = useState(0);
 const [isUploaded, setIsUploaded] = useState(false);
 const [isDateDifferenceGreater, setIsDateDifferenceGreater] = useState(false);
 const [month, setMonth] = useState("");
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const [file, setFile] = useState("");
 const ref = useRef();
 const [filteredTrainingListStatus, setFilteredTrainingListStatus] = useState(0);
 const [filteredTrainingList, setFilteredTrainingList] = useState([]);

 const [selectedCourseDetails, setSelectedCourseDetails] = useState([]);
 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };

 const downloadFile = async (event) => {
  try {
   const fileUrl = process.env.PUBLIC_URL + "/template/TrainingNominationsTemplate.xlsx";

   const response = await fetch(fileUrl);
   const blob = await response.blob();

   const blobUrl = window.URL.createObjectURL(new Blob([blob]));

   const link = document.createElement("a");
   link.href = blobUrl;
   link.download = "TrainingNominationsTemplate.xlsx"; // Name of the file to be downloaded
   link.target = "_blank";

   // Trigger the download
   document.body.appendChild(link);
   link.click();

   // Clean up
   document.body.removeChild(link);
   window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
   console.error("Error downloading the file:", error);
  }
 };
 const uploadNominationsAccess = [
  "reshmi.haridas.m",
  "arpita.m.singh",
  "aluru.akash",
  "h.srinivasan",
  "d.kumari.vaishnava",
  "varsha.a.tyagi",
  "jeevadharani.ramanan",
  "ankur.e.mishra",
  "keerthi.bhupelli",
  "narendra.reddy.mutra",
  "manasa.velagaleti",
 ];

 const [state, setState] = useState({
  openCopy: false,
  vertical: "top",
  horizontal: "center",
 });
 const { vertical, horizontal, openCopy } = state;
 const handleClickCopy = (newState) => {
  setState({ ...newState, openCopy: true });
 };
 useEffect(() => {
  if (activeAccount) {
   dispatch(updateLoginUserName(activeAccount.idTokenClaims.enterpriseID));
  } else {
   dispatch(updateLoginUserName(null));
  }
 }, [activeAccount]);
 useEffect(() => {
  if (activeAccount) {
   console.log("Active acocunt is", activeAccount.idTokenClaims.enterpriseID);
   setuserEnterpriseID(activeAccount.idTokenClaims.enterpriseID);
  } else {
   setuserEnterpriseID(null);
  }
 }, [activeAccount]);
 const handleCloseCopy = () => {
  setState({ ...state, openCopy: false });
 };
 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  //setRowsPerPage(+event.target.value);
  setPage(0);
 };
 const handleOpen = () => {
  setOpen(true);
 };

 const handleClose = () => {
  setOpen(false);
  setLoading(false);
  setFile("");
  setIsUploaded(false);
  setSuccessMessage("");
  setErrorMessage("");
 };

 const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
 };

 const handleChange = (event) => {
  setMonth(event.target.value);
  const monthNames = [
   "January",
   "February",
   "March",
   "April",
   "May",
   "June",
   "July",
   "August",
   "September",
   "October",
   "November",
   "December",
  ];

  const selectedMonthName = monthNames[event.target.value - 1];
  dispatch(getTrainingListData(selectedMonthName));
  setPage(0);
 };
 // Convert the JSON result object to a JSON string

 function formatDate(date) {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
 }

 function excelDateToJSDate(excelDate) {
  const utcDays = Math.floor(excelDate - 25569); // Excel's epoch is on 1900-01-01
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const utcMilliseconds = utcDays * millisecondsPerDay;
  const jsDate = new Date(utcMilliseconds);
  return jsDate;
 }
 const handleUpload = () => {
  if (!file) {
   setErrorMessage("Please select a file.");
   return;
  }

  const reader = new FileReader();

  reader.onload = (event) => {
   const binaryString = event.target.result;
   const workbook = XLSX.read(binaryString, { type: "binary" });

   const sheetName = workbook.SheetNames[0];
   const worksheet = workbook.Sheets[sheetName];
   //  to convert the date to correct format

   for (const cellAddress in worksheet) {
    if (!worksheet.hasOwnProperty(cellAddress)) continue;

    const cell = worksheet[cellAddress];
    if (cell.t === "n" && cell.v >= 1 && cell.v < 2958466) {
     // Check if the cell is likely a date
     const jsDate = excelDateToJSDate(cell.v);
     cell.t = "d"; // Set the type to date
     cell.w = formatDate(jsDate); // Format the date manually
     cell.v = jsDate; // Update the internal value
    }
   }

   // Print the JSON array

   function removeExtraSpacesAndTabs(str) {
    return str.replace(/\s+$/, "");
   }

   // Iterate through the columns and clean each cell value
   for (const cellRef in worksheet) {
    const cellValue = worksheet[cellRef].v;
    if (typeof cellValue === "string") {
     const cleanedValue = removeExtraSpacesAndTabs(cellValue);
     worksheet[cellRef].v = cleanedValue;
    }
   }

   const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, cellDates: true });
   // Convert date values to desired format
   for (const row of jsonData) {
    for (const key in row) {
     if (row.hasOwnProperty(key) && row[key] instanceof Date) {
      row[key] = row[key].toLocaleDateString("en-US"); // Format date as mm/dd/yyyy
     }
    }
   }
   const range = XLSX.utils.decode_range(worksheet["!ref"]);
   const emptyCells = [];
   for (let row = range.s.r; row <= range.e.r; row++) {
    for (let col = range.s.c; col <= range.e.c; col++) {
     const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
     const cell = worksheet[cellAddress];
     if (!cell || cell.v === undefined || cell.v === null) {
      emptyCells.push(cellAddress);
     }
    }
   }

   if (emptyCells.length === 0 && range.e.r > 0) {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    let finalData = {
     jsonData: jsonData,
     details: selectedCourseDetails,
    };
    Axios.post(
     `${baseURL}/uploadnominationfile/${userEnterpriseID}`,
     { finalData },
     {
      headers: {
       Authorization: localStorage.getItem("token"),
       "Content-Type": "application/json",
      },
     },
     {
      onUploadProgress: (progressEvent) => {
       const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
       setUploadProgress(progress);
      },
     }
    )
     .then((res) => {
      setSuccessMessage(res.data);
      setIsUploaded(true);
      setErrorMessage("");
      setLoading(false);
     })
     .catch((err) => {
      setErrorMessage("An error occurred while uploading the file.");
      setIsUploaded(false);
      setLoading(false);
      console.error("error is", err);
     });
   } else {
    setErrorMessage("Invalid data!. File contains empty cells!");
   }
  };

  reader.readAsBinaryString(file);
 };
 const parseDate = (dateString) => {
  const [day, month, year] = dateString.split("/").map(Number);
  return new Date(year, month - 1, day);
 };

 const getDaysDifference = (startDate, endDate) => {
  const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
  const diffInDays = Math.round((startDate - endDate) / oneDay);
  return diffInDays;
 };
 const handleClick = (index, courseCode, startDate, sessionCode, courseName) => {
  if (!uploadNominationsAccess.includes(userEnterpriseID)) {
   alert("Access is restricted, please contact for uploading LKM POCs.");
   return;
  }
  console.log(!uploadNominationsAccess.includes(userEnterpriseID));
  setSelectedCourseDetails([]);
  setUploadNomination(index);
  dispatch(getCount(courseCode, startDate));
  dispatch(getNominatedCount(courseCode, startDate));
  setSelectedCourseDetails((prevArray) => [
   ...prevArray,
   courseCode,
   courseName,
   sessionCode,
   startDate,
  ]);
  const currentDate = new Date();
  const options = { timeZone: "Asia/Kolkata" };

  const currentDateIST = currentDate.toLocaleDateString("en-IN", options);

  const toDate = parseDate(currentDateIST);
  const courseDate = parseDate(startDate);
  const daysBetweenDates = getDaysDifference(courseDate, toDate);
  if (daysBetweenDates < 7) {
   setIsDateDifferenceGreater(true);
  } else {
   setIsDateDifferenceGreater(false);
  }
  handleOpen();
 };

 const theme = createTheme({
  typography: {
   fontFamily: "Graphik-Regular",
  },
 });
 const saveFile = (e) => {
  setErrorMessage("");

  setFile(e.target.files[0]);
 };
 const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
   backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
   borderRadius: 5,
   backgroundColor: theme.palette.mode === "light" ? "#7300bd" : "#7300bd",
  },
 }));
 const [isCopied, setIsCopied] = useState(false);

 const handleCopyClick = async (copyVal) => {
  try {
   await navigator.clipboard.writeText(copyVal);
   setIsCopied(true);
  } catch (error) {
   console.error("Failed to copy:", error);
  }
 };
 useEffect(() => {
  dispatch(getCurrentMonth());
  const monthNames = [
   "January",
   "February",
   "March",
   "April",
   "May",
   "June",
   "July",
   "August",
   "September",
   "October",
   "November",
   "December",
  ];

  const selectedMonthName = monthNames[currentMonthIndex - 1];
  dispatch(getTrainingListData(selectedMonthName));
  // dispatch(getTrainingListData(currentMonth));
  setMonth(currentMonthIndex);
  console.log("currentMonthIndex", currentMonthIndex, currentMonth);
 }, []);
 return (
  <>
   <ThemeProvider theme={theme}>
    <div className="upload_section">
     <h3 className="upload_section_header">Upload Data</h3>
     <p className="upload_section_para">
      This section allows you to view the scheduled sessions and upload the nominations
      for a selected Training Session. Selecting a session will provide you the details
      like how many already nominated, how many rejected, how many are approved
      nominations who are yet to be allocated a batch.
     </p>
     <p className="upload_section_para">
      “My Nominations” section will allow you to view the status of the Nominations you
      uploaded.
     </p>
    </div>
    <SearchCourse
     trainingList={trainingList}
     setFilteredTrainingList={setFilteredTrainingList}
     setFilteredTrainingListStatus={setFilteredTrainingListStatus}
    />
    <Box className="select_month_section">
     <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Month</InputLabel>
      <Select
       labelId="demo-simple-select-label"
       id="demo-simple-select"
       value={month}
       label="Month"
       onChange={handleChange}
       displayEmpty
      >
       <MenuItem className="menu_li_select" value={1}>
        January
       </MenuItem>
       <MenuItem className="menu_li_select" value={2}>
        February
       </MenuItem>
       <MenuItem className="menu_li_select" value={3}>
        March
       </MenuItem>
       <MenuItem className="menu_li_select" value={4}>
        April
       </MenuItem>
       <MenuItem className="menu_li_select" value={5}>
        May
       </MenuItem>
       <MenuItem className="menu_li_select" value={6}>
        June
       </MenuItem>
       <MenuItem className="menu_li_select" value={7}>
        July
       </MenuItem>
       <MenuItem className="menu_li_select" value={8}>
        August
       </MenuItem>
       <MenuItem className="menu_li_select" value={9}>
        September
       </MenuItem>
       <MenuItem className="menu_li_select" value={10}>
        October
       </MenuItem>
       <MenuItem className="menu_li_select" value={11}>
        November
       </MenuItem>
       <MenuItem className="menu_li_select" value={12}>
        December
       </MenuItem>
      </Select>
     </FormControl>
    </Box>
    {trainingList.length != 0 ? (
     <Box>
      <Box className="upload_table">
       <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
         <TableHead>
          <TableRow>
           <TableCell align="center">Sl No</TableCell>
           <TableCell align="center">Course Code</TableCell>

           <TableCell align="center">Session Code</TableCell>
           <TableCell align="center">Course Name</TableCell>
           <TableCell align="center">Start Date </TableCell>
           <TableCell align="center">End Date</TableCell>
           <TableCell align="center">Delivery Mode</TableCell>
           <TableCell align="center">Duration</TableCell>
           <TableCell align="center">Total Seats Available</TableCell>

           <TableCell
            align="center"
            className="fix"
            // sx={{ width: "10%", background: "#7300BD" }}
            sx={{ width: "10%" }}
           ></TableCell>
          </TableRow>
         </TableHead>
         <TableBody>
          {trainingList.length != 0 && filteredTrainingListStatus === 0 && (
           <UploadNominationTableList
            trainingList={trainingList}
            page={page}
            rowsPerPage={rowsPerPage}
            nominateButton={nominateButton}
            setNominateButton={setNominateButton}
            handleClick={handleClick}
           />
          )}
          {trainingList.length != 0 && filteredTrainingListStatus === 1 && (
           <UploadNominationTableList
            trainingList={filteredTrainingList}
            page={page}
            rowsPerPage={rowsPerPage}
            nominateButton={nominateButton}
            setNominateButton={setNominateButton}
            handleClick={handleClick}
           />
          )}
          {trainingList.length != 0 &&
           filteredTrainingListStatus === 1 &&
           filteredTrainingList.length === 0 && (
            <TableRow>
             <TableCell>Searched courses not found.</TableCell>
            </TableRow>
           )}
          <Modal
           className="upload_modal"
           open={open}
           onClose={handleClose}
           aria-labelledby="modal-modal-title"
           aria-describedby="modal-modal-description"
          >
           {!isDateDifferenceGreater ? (
            <Box sx={style}>
             <span className="upload_close_btn_model" onClick={handleClose}>
              X
             </span>

             <Stack className="upload_button_modal_section">
              <Box>
               <Box>
                <Stack className="header_section_popup">
                 <Typography className="header_typo_popup">Upload Nomination</Typography>
                </Stack>
                <Stack className="pop_up_section">
                 <Stack className="popup_course">
                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   Course Name:&nbsp;
                   <Box>
                    {/* <Tooltip title="click to copy"> */}
                    <span
                     className="popup_span"
                     // onClick={() => {
                     //  handleCopyClick(trainingList[uploadNomination]?.courseName);
                     //  handleClickCopy({ vertical: "top", horizontal: "center" });
                     // }}
                     // style={{ cursor: "pointer" }}
                    >
                     {trainingList[uploadNomination]?.courseName}
                    </span>
                    {/* </Tooltip>  */}
                    <Snackbar
                     className="copy-snackbar"
                     anchorOrigin={{ vertical, horizontal }}
                     open={openCopy}
                     autoHideDuration={1500}
                     onClose={handleCloseCopy}
                     message="copied"
                     key={vertical + horizontal}
                     sx={{ justifyContent: "center", display: "flex" }}
                    />
                   </Box>
                  </Typography>

                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   Course Code:&nbsp;
                   {/* <Tooltip title="click to copy">
                    <span
                     className="popup_span"
                     onClick={() => {
                      handleCopyClick(trainingList[uploadNomination]?.courseCode);
                      handleClickCopy({ vertical: "top", horizontal: "center" });
                     }}
                     style={{ cursor: "pointer" }}
                    >
                     {trainingList[uploadNomination]?.courseCode}
                    </span>
                   </Tooltip> */}
                   <span className="popup_span">
                    {trainingList[uploadNomination]?.courseCode}
                   </span>
                  </Typography>
                 </Stack>
                 <Stack className="popup_course">
                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   Session Code:&nbsp;
                   <Box>
                    {/* <Tooltip title="click to copy">
                     <span
                      className="popup_span"
                      onClick={() => {
                       handleCopyClick(trainingList[uploadNomination]?.sessionCode);
                       handleClickCopy({ vertical: "top", horizontal: "center" });
                      }}
                      style={{ cursor: "pointer" }}
                     >
                      {trainingList[uploadNomination]?.sessionCode}
                     </span>
                    </Tooltip> */}
                    <span className="popup_span">
                     {trainingList[uploadNomination]?.sessionCode}
                    </span>
                   </Box>
                  </Typography>
                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   Start Date:&nbsp;
                   {/* <Tooltip title="click to copy">
                    <span
                     className="popup_span"
                     onClick={() => {
                      handleCopyClick(trainingList[uploadNomination]?.startDate);
                      handleClickCopy({ vertical: "top", horizontal: "center" });
                     }}
                     style={{ cursor: "pointer" }}
                    >
                     {trainingList[uploadNomination]?.startDate}
                    </span>
                   </Tooltip> */}
                   <span className="popup_span">
                    {trainingList[uploadNomination]?.startDate}
                   </span>
                  </Typography>
                 </Stack>
                 <Stack className="popup_course">
                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   End Date:&nbsp;
                   <span className="popup_span">
                    {trainingList[uploadNomination]?.endDate}
                   </span>
                  </Typography>
                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   Total Seats:&nbsp;
                   <span className="popup_span">
                    {trainingList[uploadNomination]?.totalSeats}
                   </span>
                  </Typography>
                 </Stack>
                 <Stack className="popup_course">
                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   Waiting for Approval:&nbsp;
                   <span className="popup_span">{nominatedCount}</span>
                  </Typography>
                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   Waiting for Batch Allocation:&nbsp;
                   <span className="popup_span">{approvedCount}</span>
                  </Typography>
                 </Stack>
                 <Stack className="popup_course">
                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   Scheduled:&nbsp;
                   <span className="popup_span">{scheduledCount}</span>
                  </Typography>
                  <Typography
                   sx={{ fontSize: "14px", fontWeight: "700", display: "flex" }}
                  >
                   Rejected:&nbsp;
                   <span className="popup_span">{rejectedCount + waitlistCount}</span>
                  </Typography>
                 </Stack>

                 <Stack>
                  <Typography sx={{ fontSize: "11px" }}>
                   * Meaning - Waiting for Batch Allocation means nominations are approved
                   and seats are yet to be allocated.
                   <span>
                    {/* <br></br>
                    Waiting for batch allocation nominations are approved and seats are yet to be allocated. */}
                    <br></br>
                    Only Scheduled nominations are considered for attending the training.
                   </span>
                  </Typography>
                 </Stack>
                </Stack>
               </Box>

               {loading === true || isUploaded ? (
                <Box className="progressBar_section">
                 <Typography sx={{ fontSize: "14px" }}>{file.name}</Typography>

                 <Box className="progress_text_section">
                  <Box
                   sx={{
                    marginTop: "7px",
                   }}
                  >
                   <BorderLinearProgress
                    className="circular_progress_upload"
                    variant="determinate"
                    value={uploadProgress}
                   />
                  </Box>
                  <Box>
                   <Typography variant="caption" component="div" color="#000">
                    {uploadProgress != 0 &&
                    uploadProgress != undefined &&
                    uploadProgress != null &&
                    !errorMessage
                     ? uploadProgress
                     : null}
                    {uploadProgress != 0 &&
                    uploadProgress != undefined &&
                    uploadProgress != null &&
                    !errorMessage
                     ? "%"
                     : null}
                   </Typography>
                  </Box>
                 </Box>
                </Box>
               ) : (
                ""
               )}

               {loading === true ? (
                <Typography className="uploading_file_text">Uploading file...</Typography>
               ) : isUploaded ? (
                <Typography className="uploading_file_text">{successMessage}</Typography>
               ) : (
                <Typography className="uploading_file_text_error">
                 {errorMessage}
                </Typography>
               )}
               {!isUploaded && !loading ? (
                <Box>
                 <Stack
                  spacing={2}
                  direction={"row"}
                  alignItems={"center"}
                  className="select_file_section"
                 >
                  <span className="file_caption">
                   {file.name != undefined && file.name != null
                    ? file.name
                    : "Choose files to upload"}
                  </span>
                  <input
                   type="file"
                   className="mainData"
                   accept=".xlsx"
                   ref={ref}
                   id="file"
                   onChange={saveFile}
                   hidden
                  />
                  <label for="file" className="custom-upload-btn">
                   Select File{" "}
                   <img
                    src="/images/Home/select-file-icon.png"
                    alt="icon"
                    className="file_name_plus_img"
                   />
                  </label>
                 </Stack>
                 <Button
                  className={
                   loading === false
                    ? "upload_button_modal_active"
                    : "upload_button_modal_inactive"
                  }
                  onClick={handleUpload}
                  sx={{ marginTop: "10px", marginLeft: "20px" }}
                 >
                  Upload
                  <img
                   src="/images/Home/upload-icon_white.png"
                   alt="icon"
                   className="upload_img"
                  />
                 </Button>
                </Box>
               ) : null}
               <div className="button_container">
                <Button
                 className={
                  activeButton ? "download_button_active" : "download_button_inactive"
                 }
                 variant="contained"
                 onClick={() => {
                  setActiveButton(!activeButton);
                  //window.open("../../template/Training Nominations Template.xlsx");
                 }}
                >
                 <a
                  // href="/template/TrainingNominationsTemplate.xlsx"
                  href="#"
                  onClick={downloadFile}
                  className={activeButton ? "download-link" : "download-link-inactive"}
                 >
                  Download template
                 </a>
                 {activeButton ? (
                  <img
                   src="/images/Home/download-icon-white.png"
                   alt="icon"
                   className="download_img"
                  />
                 ) : (
                  <img
                   src="/images/Home/download-icon.png"
                   alt="icon"
                   className="download_img"
                  />
                 )}
                </Button>
               </div>
               <Box className="instructions_accordion">
                <Accordion
                 sx={{
                  maxWidth: "100%",
                 }}
                >
                 <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                 >
                  <Typography sx={{ fontSize: "14px" }}>Instructions</Typography>
                 </AccordionSummary>
                 <AccordionDetails sx={{ width: "100%" }}>
                  <Typography sx={{ fontSize: "12px" }}>
                   Please ensure the enterprise IDs are correct, Course Code and Session
                   Code and the Date is mentioned accurately.
                  </Typography>
                 </AccordionDetails>
                </Accordion>
               </Box>
              </Box>
             </Stack>
            </Box>
           ) : (
            <Box
             sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 1,
             }}
            >
             <span className="upload_close_btn_model" onClick={handleClose}>
              X
             </span>

             <Typography
              sx={{
               textAlign: "center",
               fontSize: "18px",
               color: "blueviolet",
               padding: "30px 10px 30px 10px",
              }}
             >
              Sorry!!!<br></br> Nominations are closed for this session.
             </Typography>
            </Box>
           )}
          </Modal>
         </TableBody>
        </Table>
       </TableContainer>
       <TablePagination
        className="upload_nomination_pagination"
        component="div"
        count={trainingList.length != 0 ? trainingList.length : null}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{ width: "100% !important" }}
       />
      </Box>

      <div className="span_note_section">
       <span>
        <strong>Note: </strong>Please make sure to upload the file in the given format or
        else the nomination list will not be updated.
       </span>
      </div>
     </Box>
    ) : (
     <Stack
      justifyContent={"center"}
      alignItems={"center"}
      sx={{ marginTop: "30px", marginBottom: "100px" }}
     >
      <Stack
       spacing={2}
       justifyContent={"center"}
       alignItems={"center"}
       sx={{
        border: "solid 1px #DEDEDE",
        borderRadius: "5px",
        width: "70%",
        padding: "30px",
       }}
      >
       <img style={{ width: "100px" }} src="/images/POC/norecords.png"></img>
       <Stack direction={"row"} spacing={1}>
        <img
         style={{ width: "18px", height: "21px", marginTop: "3px" }}
         src="/images/POC/norecordsalert.png"
        ></img>
        <Typography sx={{ fontSize: "20px" }}>
         Training List for this month has not published yet!!!
        </Typography>
       </Stack>
      </Stack>
     </Stack>
    )}
   </ThemeProvider>
  </>
 );
};

function UploadNominationTableList({
 page,
 rowsPerPage,
 trainingList,
 nominateButton,
 setNominateButton,
 handleClick,
}) {
 return (
  <>
   {trainingList
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .map((row, index) => (
     <TableRow key={row.sno}>
      <TableCell align="center" scope="row">
       {row.sno}.
      </TableCell>
      <TableCell align="center" scope="row">
       {row.courseCode}
      </TableCell>
      <TableCell align="center">{row.sessionCode}</TableCell>
      <TableCell align="center">{row.courseName}</TableCell>
      <TableCell align="center">{row.startDate}</TableCell>
      <TableCell align="center">{row.endDate}</TableCell>
      <TableCell align="center">{row.deliveryMode}</TableCell>
      <TableCell align="center">{row.duration}</TableCell>
      <TableCell align="center">{row.totalSeats}</TableCell>
      <TableCell align="center" className="fix">
       <Typography
        className={
         nominateButton === index ? "nominate_text_inactive" : "nominate_text_active"
        }
        onClick={() => {
         setNominateButton(index);
         handleClick(
          row.sno - 1,
          row.courseCode,
          row.startDate,
          row.sessionCode,
          row.courseName
         );
        }}
       >
        Nominate
       </Typography>
      </TableCell>
     </TableRow>
    ))}
  </>
 );
}

export default UploadNomination;
